module.exports = new __parcel__URL__("virtual-agent-landing-app-skeleton.tpl.e8a7897b.svg").toString();